import { render, staticRenderFns } from "./DistributionReservationParameterItem.vue?vue&type=template&id=42cabe7d&scoped=true&"
import script from "./DistributionReservationParameterItem.vue?vue&type=script&lang=js&"
export * from "./DistributionReservationParameterItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cabe7d",
  null
  
)

export default component.exports